import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import CreateStaffSelector from "@cloudpivot/form/src/common/components/createStaffSelector.vue";
let DepartmentSelectorDesign = class DepartmentSelectorDesign extends Vue {
    render(h) {
        return h('create-staff-selector', { props: { opts: { disabled: true }
            } });
    }
};
tslib_1.__decorate([
    Prop()
], DepartmentSelectorDesign.prototype, "control", void 0);
DepartmentSelectorDesign = tslib_1.__decorate([
    Component({
        name: 'DepartmentSelectorDesign',
        components: {
            CreateStaffSelector
        }
    })
], DepartmentSelectorDesign);
export default DepartmentSelectorDesign;
